import { format } from 'date-fns';

type DateTimeProps = {
  date: string;
  hideTime?: boolean;
  noBreak?: boolean;
}
export default function DateTime({ date, hideTime, noBreak }: DateTimeProps) {
  const [d, t] = format(new Date(date), "dd/MM/yyyy '-' HH:mm").split('-');
  return (
    <>
      {d}
      { !hideTime && (
        <>
        { !noBreak && (
          <><br /><small>{t}</small></>
        )}
        { noBreak && <>{` - ${t}`}</> }
        </>
      ) }
    </>
  )
}
